export const POLLING_DURATION = 5000
